import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "layout-page" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "flex-grow-1 container-p-y px-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between aling-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold py-3 mb-4 ps-2" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "text-muted fw-light" }, "Invoice "),
      /*#__PURE__*/_createTextVNode("View ")
    ])
  ])
], -1)
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "text-nowrap" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "row invoice-preview"
}
const _hoisted_16 = { class: "col-xl-9 col-md-8 col-12 mb-md-0 mb-4" }
const _hoisted_17 = {
  class: "card invoice-preview-card",
  id: "invoice-container"
}
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "d-flex justify-content-between flex-xl-row flex-md-column flex-sm-row flex-column p-sm-3 p-0" }
const _hoisted_20 = { class: "text-wrap" }
const _hoisted_21 = { class: "mb-2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Date:", -1)
const _hoisted_23 = { class: "fw-medium" }
const _hoisted_24 = { class: "mb-xl-0 mb-4" }
const _hoisted_25 = { class: "d-flex svg-illustration mb-2 gap-2" }
const _hoisted_26 = { class: "app-brand-text demo menu-text fw-bolder text-uppercase" }
const _hoisted_27 = { class: "mb-1" }
const _hoisted_28 = { class: "mb-0" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_30 = { class: "card-body" }
const _hoisted_31 = { class: "row p-sm-3 p-0" }
const _hoisted_32 = { class: "col-xl-12 col-md-12 col-sm-7 col-12" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Customer: ")
], -1)
const _hoisted_34 = { key: 0 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Name: ", -1)
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Type: ", -1)
const _hoisted_38 = { key: 2 }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Phone:", -1)
const _hoisted_40 = { key: 3 }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Address:", -1)
const _hoisted_42 = { class: "d-none d-md-block" }
const _hoisted_43 = { class: "table-responsive mx-4" }
const _hoisted_44 = { class: "table table-bordered m-0 text-center" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty X Price "),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "text-end"
}, "Total =", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "text-end"
}, "Discount = ", -1)
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "text-end"
}, "Due =", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "text-end"
}, "Sub Total =", -1)
const _hoisted_51 = { class: "mobile-view d-block d-md-none" }
const _hoisted_52 = { class: "mb-4" }
const _hoisted_53 = { class: "card-body" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("strong", null, " Order Details: ")
], -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = { class: "mb-0" }
const _hoisted_57 = { class: "mb-0" }
const _hoisted_58 = { class: "mb-0" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_60 = { class: "mb-0 text-end" }
const _hoisted_61 = /*#__PURE__*/_createTextVNode(" Total: ")
const _hoisted_62 = { class: "mb-0 text-end" }
const _hoisted_63 = { class: "mb-0 text-end" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Sub Total: ")
const _hoisted_65 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"row\"><div class=\"col-12\"><span class=\"text-wrap\">Design &amp; Developed by <strong>PhicsArt</strong>!  <img src=\"https://phicsart.com/uploads/images/top-page/menu/logo.svg\" alt=\"\" class=\"img-fluid\" style=\"max-width:13px;\"></span></div></div></div>", 1)
const _hoisted_66 = { class: "col-sm-3 d-none" }
const _hoisted_67 = { id: "invoice-container-57mm" }
const _hoisted_68 = { class: "card invoice-preview-card" }
const _hoisted_69 = { class: "card-body m-0" }
const _hoisted_70 = { class: "" }
const _hoisted_71 = { class: "mb-xl-0" }
const _hoisted_72 = { class: "d-flex svg-illustration mb-2 gap-2" }
const _hoisted_73 = { class: "app-brand-text demo menu-text fw-bolder text-uppercase" }
const _hoisted_74 = { class: "mb-0" }
const _hoisted_75 = { class: "mb-0" }
const _hoisted_76 = { class: "text-wrap m-0" }
const _hoisted_77 = { class: "mb-2" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Date:", -1)
const _hoisted_79 = { class: "fw-medium" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_81 = { class: "card-body" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Customer: ")
], -1)
const _hoisted_83 = { class: "table" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Name: ", -1)
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Type: ", -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Phone:", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Address:", -1)
const _hoisted_88 = { class: "" }
const _hoisted_89 = { class: "table text-center" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty "),
    /*#__PURE__*/_createElementVNode("th", null, "Price "),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Total =", -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Discount = ", -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Sub Total =", -1)
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"row\"><div class=\"col-12\"><span class=\"text-wrap\">Design &amp; Developed by <strong>PhicsArt</strong>!  <img src=\"https://phicsart.com/uploads/images/top-page/menu/logo.svg\" alt=\"\" class=\"img-fluid\" style=\"max-width:13px;\"></span></div></div></div>", 1)
const _hoisted_95 = { class: "col-sm-4 d-none" }
const _hoisted_96 = { id: "invoice-container-80mm" }
const _hoisted_97 = { class: "card" }
const _hoisted_98 = { class: "card-body m-0" }
const _hoisted_99 = { class: "" }
const _hoisted_100 = { class: "mb-xl-0" }
const _hoisted_101 = { class: "d-flex svg-illustration mb-2 gap-2" }
const _hoisted_102 = { class: "app-brand-text demo menu-text fw-bolder text-uppercase" }
const _hoisted_103 = { class: "mb-0" }
const _hoisted_104 = { class: "mb-0" }
const _hoisted_105 = { class: "text-wrap m-0" }
const _hoisted_106 = { class: "mb-2" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Date:", -1)
const _hoisted_108 = { class: "fw-medium" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1)
const _hoisted_110 = { class: "card-body" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("h6", { class: "pb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Customer: ")
], -1)
const _hoisted_112 = { class: "table" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Name: ", -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Type: ", -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Phone:", -1)
const _hoisted_116 = /*#__PURE__*/_createElementVNode("td", { class: "pe-3" }, "Address:", -1)
const _hoisted_117 = { class: "" }
const _hoisted_118 = { class: "table text-center" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Id"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Qty "),
    /*#__PURE__*/_createElementVNode("th", null, "Price "),
    /*#__PURE__*/_createElementVNode("th", null, "Total")
  ])
], -1)
const _hoisted_120 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Total =", -1)
const _hoisted_121 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Discount = ", -1)
const _hoisted_122 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "4",
  class: "text-end"
}, "Sub Total =", -1)
const _hoisted_123 = /*#__PURE__*/_createStaticVNode("<div class=\"card-body\"><div class=\"row\"><div class=\"col-12\"><span class=\"text-wrap\">Design &amp; Developed by <strong>PhicsArt</strong>!  <img src=\"https://phicsart.com/uploads/images/top-page/menu/logo.svg\" alt=\"\" class=\"img-fluid\" style=\"max-width:13px;\"></span></div></div></div>", 1)
const _hoisted_124 = { class: "col-xl-3 col-md-4 col-12 invoice-actions" }
const _hoisted_125 = { class: "card mb-3" }
const _hoisted_126 = { class: "card-body" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-printer" }),
  /*#__PURE__*/_createTextVNode("   Print A4")
], -1)
const _hoisted_128 = [
  _hoisted_127
]
const _hoisted_129 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-printer" }),
  /*#__PURE__*/_createTextVNode("   Print 80MM")
], -1)
const _hoisted_130 = [
  _hoisted_129
]
const _hoisted_131 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-printer" }),
  /*#__PURE__*/_createTextVNode("   Print 57MM")
], -1)
const _hoisted_132 = [
  _hoisted_131
]
const _hoisted_133 = /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bx bx-download" }),
  /*#__PURE__*/_createTextVNode("   PDF Download")
], -1)
const _hoisted_134 = [
  _hoisted_133
]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-label-secondary border d-grid w-100 mb-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-flex align-items-center justify-content-center text-nowrap" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "bx bx-paper-plane bx-xs me-1" }),
    /*#__PURE__*/_createTextVNode("Send Mail")
  ])
], -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("div", { class: "content-backdrop fade" }, null, -1)
const _hoisted_137 = /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopBarView = _resolveComponent("TopBarView")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_TopBarView),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              (_ctx.loading)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                                : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", _hoisted_19, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("h4", _hoisted_20, "Invoice No: " + _toDisplayString(_ctx.orderData.invoice_no), 1),
                                              _createElementVNode("div", _hoisted_21, [
                                                _hoisted_22,
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.orderData.created_at), 1)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_24, [
                                              _createElementVNode("div", _hoisted_25, [
                                                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.storeData.name), 1)
                                              ]),
                                              _createElementVNode("p", _hoisted_27, "Address: " + _toDisplayString(_ctx.orderData?.store?.address), 1),
                                              _createElementVNode("p", _hoisted_28, "Phone: " + _toDisplayString(_ctx.orderData?.store?.phone), 1)
                                            ])
                                          ])
                                        ]),
                                        _hoisted_29,
                                        _createElementVNode("div", _hoisted_30, [
                                          _createElementVNode("div", _hoisted_31, [
                                            _createElementVNode("div", _hoisted_32, [
                                              _hoisted_33,
                                              _createElementVNode("table", null, [
                                                _createElementVNode("tbody", null, [
                                                  (_ctx.orderData?.customer?.name)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_34, [
                                                        _hoisted_35,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.name), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.orderData?.customer_type)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [
                                                        _hoisted_37,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_type), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.orderData?.customer?.phone)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [
                                                        _hoisted_39,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.phone), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.orderData?.customer?.address)
                                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [
                                                        _hoisted_41,
                                                        _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.address), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_42, [
                                          _createElementVNode("div", _hoisted_43, [
                                            _createElementVNode("table", _hoisted_44, [
                                              _hoisted_45,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_items, (dataItem, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem?.product_name), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.quantity) + " x " + _toDisplayString(dataItem.sell_price), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.total), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _createElementVNode("tfoot", null, [
                                                _createElementVNode("tr", null, [
                                                  _hoisted_46,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.total), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_47,
                                                  _createElementVNode("th", null, _toDisplayString((_ctx.orderData.total - _ctx.orderData.sub_total).toFixed(2)), 1)
                                                ]),
                                                (_ctx.orderData.due < 0)
                                                  ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [
                                                      _hoisted_49,
                                                      _createElementVNode("th", null, _toDisplayString(_ctx.orderData.due), 1)
                                                    ]))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_50,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.sub_total), 1)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_51, [
                                          _createElementVNode("div", _hoisted_52, [
                                            _createElementVNode("div", _hoisted_53, [
                                              _hoisted_54,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_items, (dataItem, index) => {
                                                return (_openBlock(), _createElementBlock("div", { key: index }, [
                                                  _createElementVNode("strong", null, " Sl: " + _toDisplayString(index + 1), 1),
                                                  _hoisted_55,
                                                  _createElementVNode("p", _hoisted_56, [
                                                    _createElementVNode("strong", null, " Name: " + _toDisplayString(dataItem?.product_name), 1)
                                                  ]),
                                                  _createElementVNode("p", _hoisted_57, "Qty X Price: " + _toDisplayString(dataItem.quantity) + " x " + _toDisplayString(dataItem.sell_price), 1),
                                                  _createElementVNode("p", _hoisted_58, "Total: " + _toDisplayString(dataItem.total), 1),
                                                  _hoisted_59
                                                ]))
                                              }), 128)),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_60, [
                                                  _hoisted_61,
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.orderData.total), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_62, " Discount: " + _toDisplayString((_ctx.orderData.total - _ctx.orderData.sub_total).toFixed(2)), 1),
                                                _createElementVNode("p", _hoisted_63, [
                                                  _hoisted_64,
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.orderData.sub_total), 1)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _hoisted_65
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_66, [
                                      _createElementVNode("div", _hoisted_67, [
                                        _createElementVNode("div", _hoisted_68, [
                                          _createElementVNode("div", _hoisted_69, [
                                            _createElementVNode("div", _hoisted_70, [
                                              _createElementVNode("div", _hoisted_71, [
                                                _createElementVNode("div", _hoisted_72, [
                                                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.storeData.name), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_74, "Address: " + _toDisplayString(_ctx.orderData?.store?.address), 1),
                                                _createElementVNode("p", _hoisted_75, "Phone: " + _toDisplayString(_ctx.orderData?.store?.phone), 1)
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("h4", _hoisted_76, "Invoice No: " + _toDisplayString(_ctx.orderData.invoice_no), 1),
                                                _createElementVNode("div", _hoisted_77, [
                                                  _hoisted_78,
                                                  _createElementVNode("span", _hoisted_79, _toDisplayString(_ctx.orderData.created_at), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _hoisted_80,
                                          _createElementVNode("div", _hoisted_81, [
                                            _hoisted_82,
                                            _createElementVNode("table", _hoisted_83, [
                                              _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                  _hoisted_84,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.name), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_85,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_type), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_86,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.phone), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_87,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.address), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("table", _hoisted_89, [
                                              _hoisted_90,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_items, (dataItem, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem?.product_name), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.quantity), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.sell_price), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.total), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _createElementVNode("tfoot", null, [
                                                _createElementVNode("tr", null, [
                                                  _hoisted_91,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.total), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_92,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.discount), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_93,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.sub_total), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _hoisted_94
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_95, [
                                      _createElementVNode("div", _hoisted_96, [
                                        _createElementVNode("div", _hoisted_97, [
                                          _createElementVNode("div", _hoisted_98, [
                                            _createElementVNode("div", _hoisted_99, [
                                              _createElementVNode("div", _hoisted_100, [
                                                _createElementVNode("div", _hoisted_101, [
                                                  _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.storeData.name), 1)
                                                ]),
                                                _createElementVNode("p", _hoisted_103, "Address: " + _toDisplayString(_ctx.orderData?.store?.address), 1),
                                                _createElementVNode("p", _hoisted_104, "Phone: " + _toDisplayString(_ctx.orderData?.store?.phone), 1)
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createElementVNode("h4", _hoisted_105, "Invoice No: " + _toDisplayString(_ctx.orderData.invoice_no), 1),
                                                _createElementVNode("div", _hoisted_106, [
                                                  _hoisted_107,
                                                  _createElementVNode("span", _hoisted_108, _toDisplayString(_ctx.orderData.created_at), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _hoisted_109,
                                          _createElementVNode("div", _hoisted_110, [
                                            _hoisted_111,
                                            _createElementVNode("table", _hoisted_112, [
                                              _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                  _hoisted_113,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.name), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_114,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer_type), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_115,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.phone), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_116,
                                                  _createElementVNode("td", null, _toDisplayString(_ctx.orderData?.customer?.address), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_117, [
                                            _createElementVNode("table", _hoisted_118, [
                                              _hoisted_119,
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderData.order_items, (dataItem, index) => {
                                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem?.product_name), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.quantity), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.sell_price), 1),
                                                    _createElementVNode("td", null, _toDisplayString(dataItem.total), 1)
                                                  ]))
                                                }), 128))
                                              ]),
                                              _createElementVNode("tfoot", null, [
                                                _createElementVNode("tr", null, [
                                                  _hoisted_120,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.total), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_121,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.discount), 1)
                                                ]),
                                                _createElementVNode("tr", null, [
                                                  _hoisted_122,
                                                  _createElementVNode("th", null, _toDisplayString(_ctx.orderData.sub_total), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _hoisted_123
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_124, [
                                      _createElementVNode("div", _hoisted_125, [
                                        _createElementVNode("div", _hoisted_126, [
                                          _createElementVNode("button", {
                                            class: "btn btn-primary d-grid w-100 mb-3",
                                            "data-bs-toggle": "offcanvas",
                                            "data-bs-target": "#sendInvoiceOffcanvas",
                                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.printInvoice('print')))
                                          }, _hoisted_128),
                                          _createElementVNode("button", {
                                            class: "btn btn-default border d-grid w-100 mb-3",
                                            "data-bs-toggle": "offcanvas",
                                            "data-bs-target": "#sendInvoiceOffcanvas",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.printInvoice('80mm')))
                                          }, _hoisted_130),
                                          _createElementVNode("button", {
                                            class: "btn btn-default border d-grid w-100 mb-3",
                                            "data-bs-toggle": "offcanvas",
                                            "data-bs-target": "#sendInvoiceOffcanvas",
                                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.printInvoice('57mm')))
                                          }, _hoisted_132),
                                          _createElementVNode("button", {
                                            class: "btn btn-label-secondary btn-default border d-grid w-100 mb-3",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadInvoice(_ctx.orderData)))
                                          }, _hoisted_134),
                                          _hoisted_135
                                        ])
                                      ])
                                    ])
                                  ]))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_Footer),
        _hoisted_136
      ])
    ]),
    _hoisted_137
  ], 64))
}